import axios from 'axios';
import {
    FETCH_SALE_PROVINCE_PENDING,
    FETCH_SALE_PROVINCE_SUCCESS,
    FETCH_SALE_PROVINCE_FAILURE,
    MAP_FILTER,
    MAP_YEAR_FILTER
} from '../constants/ActionTypes';

export const fetchSaleProvincePending = () => {
    return {
        type: FETCH_SALE_PROVINCE_PENDING
    }
}

export const fetchSaleProvinceSuccess = data => {
    return {
        type: FETCH_SALE_PROVINCE_SUCCESS,
        payload: data
    }
}

export const fetchSaleProvinceFailure = error => {
    return {
        type: FETCH_SALE_PROVINCE_FAILURE,
        payload: error
    }
}

export const fetchSaleProvince = (payload) => {
    
    const { company, username, salesmanCode, language, calendarType, year, qtr, month, 
            com, salesOrg, channel, parentSalesman, salesArea, salesman, filter, selectYear } = payload;

    return dispatch => {
        dispatch(fetchSaleProvincePending());

        const url = `${process.env.REACT_APP_API_URL}salesman/saleByProvince?company=${company}&username=${username}&salesmanCode=${salesmanCode}&language=${language}&calendarType=${calendarType}&year=${year}&qtr=${qtr}&month=${month}&com=${com}&salesOrg=${salesOrg}&channel=${channel}&parentSalesman${parentSalesman}&salesArea=${salesArea}&salesman=${salesman}&filter=${filter}&selectYear=${selectYear}`;
        axios.get(url, {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}})
        .then(res => {
            let data = [];
            let PercentAmount = null

            if(res.data.length > 0){
                res.data.forEach((sale) => {
                    //Calculate Percentage
                    if(sale.CurrAmount > 0 && sale.PrevAmount <= 0){
                        PercentAmount = 100
                    }else if(sale.CurrAmount <= 0 && sale.PrevAmount <= 0){
                        PercentAmount = 0
                    }else if(sale.CurrAmount <= 0 && sale.PrevAmount >= 0){
                        PercentAmount = 0
                    }else{
                        PercentAmount = (sale.CurrAmount * 100) / sale.PrevAmount
                    }
                    data.push({...sale, PercentAmount: PercentAmount})
                })
            }

            dispatch(fetchSaleProvinceSuccess(data));
        })
        .catch(error => {
            dispatch(fetchSaleProvinceFailure(error.response))
        })
    }
}

export const mapSelectedFilter = payload => {
    return {
        type: MAP_FILTER,
        payload
    }
}

export const mapYearSelected = payload => {
    return {
        type: MAP_YEAR_FILTER,
        payload
    }
}